import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {NgForm} from '@angular/forms';
import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {StudentService} from '../../services/student.service';
import {DistrictAcademicArea, DistrictService} from '../../services/district.service';
import {Level, ToastService} from '../../services/toast.service';
import {TypesService} from '../../services/types.service';
import {LoggingService} from '../../services/logging';
import {ObservationDto, StaffDto} from '@sidr/dto-types';



@Component({
  selector: `student-observationdialog`,
  templateUrl: 'student.observationdialog.component.html'
})
export class StudentObservationDialogComponent implements OnInit {
  @Input() observation: ObservationDto;
  @ViewChild('obsForm') obsForm: NgForm;
  original: ObservationDto;
  @Input() edit: boolean;
  @Input() districtId: string;
  @Input() studentId: string;

  update: boolean;
  staff: StaffDto[];
  academic_areas: DistrictAcademicArea[];

  NotificationTitle = 'Observations';

  constructor(public activeModal: NgbActiveModal,
              private studentService: StudentService,
              private districtService: DistrictService,
              private typesService: TypesService,
              private toastService: ToastService) {
    this.edit = false;
    this.academic_areas = [];

    this.update = false;
  }

  editObservation() {
    this.original = {...this.observation}
    this.edit = true;
  }

  cancel() {
    if (!this.observation.id || this.observation.id.length === 0) {
      if (this.obsForm.touched && !confirm('Unsaved data, are you sure you want to close?')) {
        return;
      }
      this.edit = false;
    } else if (this.edit) {
      this.observation = {...this.original};
      this.edit = false;
      this.obsForm.form.markAsPristine();
    }
  }

  close() {
    if (this.edit && this.obsForm.touched && confirm('Unsaved data, are you sure you want to close?')) {
      this.activeModal.dismiss(this.update);
    } else {
      this.activeModal.dismiss(this.update);
    }
  }

  onStaffChange(form: NgForm, ids: string[]) {
    this.observation.observer_ids = ids || [];
    form.form.markAsDirty();
  }

  submit(f: NgForm) {
    let obs = this.observation.id ?
      this.studentService.patchObservation(this.districtId, this.studentId, this.observation) :
      this.studentService.postObservation(this.districtId, this.studentId, this.observation);

    obs.subscribe(r => {
      f.form.markAsPristine();
      this.observation = r;
      this.edit = false;
      this.toastService.AddNotification(Level.SUCCESS, this.NotificationTitle, 'Saved observation');
    }, err => {
      this.toastService.AddNotification(Level.ERROR, this.NotificationTitle, 'Failed to save observation.');
    })
  }

  ngOnInit(): void {
    this.typesService.getBasicType(this.districtId, TypesService.AcademicArea).subscribe(resp => {
      this.academic_areas = resp || [];
    });
    this.districtService.getActiveStaff(this.districtId).subscribe(resp => {
      this.staff = resp || [];
    });
  }

}
